<template>
    <b-card>
        <!-- filter  -->
        <div v-if="loading" class="text-center mt-4">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="col-12 mt-16">
            <div>
                <b-row class="align-items-center">
                    <b-col lg="4" class="my-1">
                        <b-form-group label="" label-for="filter-input" label-cols-sm="1" label-align-sm="right"
                            label-size="sm" class="mb-0">
                            <b-input-group size="sm">
                                <b-form-input id="filter-input" v-model="filter" type="search"
                                    placeholder="Type to Search"></b-form-input>
                                <b-input-group-append>
                                    <b-button @click="applyFilter" :disabled="!filter"
                                        variant="primary">Apply</b-button>
                                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <!-- .. Filter  for   date-->
                    <b-col lg="3" class="my-1">
                        <b-form-input id="start-date" v-model="startDateFilter" type="date"
                            placeholder="Select start date"></b-form-input>
                    </b-col>
                    <b-col lg="3" class="my-1">
                        <b-form-input id="end-date" v-model="endDateFilter" type="date" placeholder="Select end date"
                            @change="changeDate"></b-form-input>
                    </b-col>
                    <!-- Filter  for   date-  -->

                    <input type="file" ref="fileInput" @change="handleFileUpload" accept=".csv"
                        style="display: none;" />
                    <b-col lg="2" class="my-1 d-flex justify-content-end">
                        <b-button @click="exportAllDataToCSV" variant="primary" class="mb-8 mr-8">Export</b-button>
                    </b-col>
                </b-row>
            </div>
        </div>

        <b-modal id="gps-tracking-modal" size="xl" title="GPS Tracking" hide-footer @hidden="clearMapInterval"
            @shown="initMap">
            <div class="text-right mb-2">
    <a 
    :href="'https://www.overseetracking.com?SystemNo=' + gpsData.SystemNo" 
      target="_blank" 
      rel="noopener noreferrer"
      class="d-inline-block"
    >
      <b-button variant="primary" class="mb-3">
        <b-icon icon="box-arrow-up-right" class="mr-2"></b-icon>
        Open Full Tracking Portal
      </b-button>
    </a>
  </div>
            <div v-if="gpsLoading" class="text-center">
                <b-spinner label="Loading GPS Data..."></b-spinner>
            </div>
            <div v-else>
                <div v-if="gpsError" class="alert alert-danger">
                    {{ gpsError }}
                </div>
                <div v-else>
                    <div class="mb-4">
                        <b-row>
                            <b-col><strong>Plate No:</strong> {{ gpsData.PlateNo }}</b-col>
                            <b-col><strong>Last Update:</strong> {{ formatGpsDateTime(gpsData.DateTime) }}</b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col><strong>Speed:</strong> {{ gpsData.Speed }} km/h</b-col>
                            <b-col><strong>Voltage:</strong> {{ gpsData.Voltage }}V</b-col>
                            <b-col><strong>Mileage:</strong> {{ gpsData.Mileage }} km</b-col>
                        </b-row>
                    </div>
                    <div id="map" style="height: 500px; width: 100%;"></div>
                </div>
            </div>
        </b-modal>

        <!-- filter end -->
        <b-row>
            <div class="col-12 mt-16">
                <b-skeleton-table
                    v-if="loading"
                    :rows="perPage"
                    :columns="fields.length"
                    animation="wave"
                    bordered
                    class="mb-3"
                    />
                <b-table v-else id="dataTable" :items="users" :busy.sync="loading" :fields="fields" :current-page="currentPage"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty responsive striped hover class="custom-zebra">


                    <template #cell(vehicle_name)="row">
                        {{ row.item.vehicle ? row.item.vehicle.name : 'N/A' }}
                    </template>
                    <template #cell(vehicle_type)="row">
                        {{ row.item.vehicle ? row.item.vehicle.vehicle_type : 'N/A' }}
                    </template>
                    <template #cell(company_name)="row">
                        {{ row.item.company_name ? row.item.company_name : 'N/A' }}
                    </template>
                    <template #cell(uic)="row">
                        {{ row.item.uic ? row.item.uic : 'N/A' }}
                    </template>

                    <template #cell(vin)="row">
                        {{ row.item.vin || 'N/A' }}
                    </template>

                    <template #cell(color)="row">
                        {{ row.item.color || 'N/A' }}
                    </template>

                    <template #cell(license_plate)="row">
                        {{ row.item.license_plate || 'N/A' }}
                    </template>

                    <template #cell(registration_number)="row">
                        {{ row.item.registration_number || 'N/A' }}
                    </template>

                    <template #cell(status)="row">
                        <span :style="{ color: row.item.status ? 'red' : 'black' }">
                            {{ row.item.status || 'N/A' }}
                        </span>
                    </template>

                    <template #cell(types)="row">
                        <span :style="{ color: row.item.status ? 'green' : 'black' }">
                            {{ row.item.types || 'N/A' }}
                        </span>
                    </template>


                    <template #cell(title)="row">
                        {{ row.item.model?.title || 'N/A' }}
                    </template>

                    <template #cell(name)="row">
                        {{ row.item.brand?.name || 'N/A' }}
                    </template>
                    <template v-slot:cell(created_at)="data">
                        {{ formatDate(data.item.created_at) }}
                    </template>
                    <template v-slot:cell(created_at_time)="data">
                        {{ formatTime(data.item.created_at) }}
                    </template>

                    <template #cell(actions)="row">
                        <b-button v-b-tooltip.hover title="See Tracking"  @click="seeTrack(row.item.user_id, row.item.id)" variant="primary" class="mb-8 mr-8">
                            WOSS App Tracking
                        </b-button>
                        <div>
                            <!-- GPS Tracking Button -->
                            <b-button  v-b-tooltip.hover title="See GPS Tracking" @click="GPSTrack(row.item.SystemNo)" variant="primary" class="mb-8 mr-8">
                                WOSS GPS Tracking
                            </b-button>
                        </div>

                    </template>
                    <b-form-group label="Filter" label-for="filter-input" label-cols-sm="3" label-align-sm="right"
                        label-size="sm" class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input id="filter-input" v-model="filter" type="search"
                                placeholder="Type to Search"></b-form-input>

                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-table>
                <div class="mx-8 d-flex justify-content-end">
                    <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage"
                        aria-controls="dataTable" @change="pageChanged"></b-pagination>
                </div>
                <b-row class="mt-16 align-items-center justify-content-end">
                    <b-row>
                    </b-row>
                </b-row>
            </div>
        </b-row>
    </b-card>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    BInputGroupAppend,
    BSpinner,
    BSkeleton,
    BSkeletonTable,
} from "bootstrap-vue";
import axios from "../../../axios";
import Papa from "papaparse";
import { navigateIfVehicleLocationAvailable } from "@/utils/vehicleLocation";
import { launchGpsTracking } from "@/utils/overseeTracking";

export default {
    // props: ['notification'],
    data() {
        return {
            filter: "",
            total: 0,
            perPage: 10,
            currentPage: 1,
            lastPage: 0,
            firstPageUrl: null,
            lastPageUrl: null,
            nextPageUrl: null,
            prevPageUrl: null,
            isLoading: false,
            sortBy: "",
            sortDesc: false,
            selectedCardOption: "",
            rowToUpdate: null,
            modalVisible: false,
            modalVisibleDoument: false,
            editMode: false,
            users: [],
            fields: [
                { key: "id", sortable: true },
                { key: "model.title", label: "Model", sortable: true },
                { key: "SystemNo", sortable: true },
                { key: "color", sortable: true },
                { key: "license_plate", sortable: true },
                { key: "brand.name", label: "Brand", sortable: true },
                { key: "registration_number", sortable: true },
                { key: "vin", label: "Vehicle Identification Number", sortable: true },
                { key: "uic", label: "Unique Identification Code", sortable: true },
                { key: "year", sortable: true },
                { key: "types", sortable: true },
                { key: "created_at", label: "Date", formatter: this.formatDate },
                { key: "created_at_time", label: "Time" },
                { key: "status", sortable: true },
                { key: "actions", label: "Actions" },
            ],

            showDeleteConfirmations: false,
            itemIdToDelete: null,
            loading: false,
            startDateFilter: null,
            endDateFilter: null,
            ended_date: "",
            selected_date: "",
            your_vehicle_id: null,
            company_name: "",
            model: "",
            color: "",
            license_plate: "",
            make: "",
            types: "",
            registration_number: "",
            vin: "",
            uic: "",
            year: "",
            status: "",
            showModal: false,
            selectedVehicleId: null,
            type: "",
            userId: "",
            gpsLoading: false,
            gpsError: null,
            gpsData: null,
            map: null,
            marker: null,
            gpsData: {
                PlateNo: '',
                SystemNo: '',
                DateTime: '',
                Longitude: 0,
                Latitude: 0,
                Speed: 0,
                Angle: 0,
                Altitude: 0,
                Acc: 0,
                GpsStatus: 0,
                Oil: 0,
                Voltage: 0,
                Mileage: 0,
                Temperature: 0
            },
            map: null,
            marker: null,
            updateInterval: null,
            currentSystemNo: null,

        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BTable,
        BFormGroup,
        BInputGroup,
        BFormInput,
        BFormSelect,
        BPagination,
        BInputGroupAppend,
        BSpinner,
        BSkeleton,
        BSkeletonTable,
    },
    computed: {
        sortOptions() {
            return this.fields
                .filter((f) => f.sortable)
                .map((f) => {
                    return { text: f.label, value: f.key };
                });
        },
        rows() {
            return this.users.length;
        },
    },

    mounted() {
        this.fetchData();
        this.preFillVin();
    },
    methods: {
        async GPSTrack(SystemNo) {
            this.gpsLoading = true;
            this.gpsError = null;
            this.currentSystemNo = SystemNo;

            try {
                const result = await launchGpsTracking(this, axios, SystemNo);
                if (!result.ok) {
                    this.gpsError = result.error;
                    this.$bvToast.toast(result.error, {
                        title: 'GPS Unavailable',
                        variant: 'danger',
                        solid: true,
                    });
                    return;
                }
                if (result.mode === 'embedded') {
                    this.gpsData = result.gpsData;
                    this.$bvModal.show('gps-tracking-modal');
                }
            } catch (error) {
                console.error('GPS Tracking Error:', error);
                this.gpsError = error.message || 'Failed to load GPS data';
            } finally {
                this.gpsLoading = false;
            }
        },

        initMap() {
            // Load Google Maps API if not already loaded
            if (!window.google) {
                this.loadGoogleMaps().then(() => {
                    this.createMap();
                    this.startGpsUpdateInterval();
                });
            } else {
                this.createMap();
                this.startGpsUpdateInterval();
            }
        },

        clearMapInterval() {
            if (this.updateInterval) {
                clearInterval(this.updateInterval);
                this.updateInterval = null;
            }
            if (this.marker) {
                this.marker.setMap(null);
                this.marker = null;
            }
            this.map = null;
        },

        startGpsUpdateInterval() {
            this.updateInterval = setInterval(this.fetchLatestGpsData, 5000); // Update every 10 seconds
        },

        async fetchLatestGpsData() {
            if (!this.currentSystemNo || !this.map) {
                return;
            }
            try {
                const gpsResponse = await axios.get('/getGPSData', {
                    params: { SystemNo: this.currentSystemNo }
                });

                if (
                    gpsResponse.data.status === "success" &&
                    gpsResponse.data.data &&
                    gpsResponse.data.data.length > 0
                ) {
                    this.gpsData = gpsResponse.data.data[0];
                    this.updateMapMarker();
                } else {
                    console.error("No GPS data available for update.");
                }
            } catch (error) {
                console.error("Error fetching latest GPS data:", error);
            }
        },

        updateMapMarker() {
            const newPosition = {
                lat: parseFloat(this.gpsData.Latitude),
                lng: parseFloat(this.gpsData.Longitude)
            };
            if (this.marker) {
                this.marker.setPosition(newPosition);
                const infoWindow = new google.maps.InfoWindow({
                    content: `
            <div>
              <strong>${this.gpsData.PlateNo}</strong><br>
              <strong>Status:</strong> ${this.gpsData.GpsStatus === 1 ? 'Active' : 'Inactive'}<br>
              <strong>Last Update:</strong> ${this.formatGpsDateTime(this.gpsData.DateTime)}<br>
              <strong>Speed:</strong> ${this.gpsData.Speed} km/h
            </div>
          `
                });
                infoWindow.open(this.map, this.marker);
                this.map.setCenter(newPosition);
            } else {
                this.createMap(); // Re-create the map and marker if it somehow got lost
            }
        },

        loadGoogleMaps() {
            return new Promise((resolve) => {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDYFf3v05WKADd-Ex6_zViktqXl26gNjgI&libraries=places`;
                script.onload = resolve;
                document.head.appendChild(script);
            });
        },

        createMap() {
            const position = {
                lat: parseFloat(this.gpsData.Latitude),
                lng: parseFloat(this.gpsData.Longitude)
            };
            const carSymbol = {
                path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW, // A basic arrow shape
                scale: 5,
                rotation: 0,
                strokeColor: 'blue',
                fillColor: 'blue',
                fillOpacity: 1
            };

            // Create the map
            this.map = new google.maps.Map(document.getElementById("map"), {
                zoom: 15,
                center: position,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: true, // Enable map type control
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                    mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain']
                }
            });

            // Add a marker with the car icon
            this.marker = new google.maps.Marker({
                position: position,
                map: this.map,
                title: this.gpsData.PlateNo,
                icon: carSymbol
            });

            // Add an info window
            const infoWindow = new google.maps.InfoWindow({
                content: `
          <div>
            <strong>${this.gpsData.PlateNo}</strong><br>
            <strong>Status:</strong> ${this.gpsData.GpsStatus === 1 ? 'Active' : 'Inactive'}<br>
            <strong>Last Update:</strong> ${this.formatGpsDateTime(this.gpsData.DateTime)}<br>
            <strong>Speed:</strong> ${this.gpsData.Speed} km/h
          </div>
        `
            });

            this.marker.addListener('click', () => {
                infoWindow.open(this.map, this.marker);
            });

            // Open info window by default
            infoWindow.open(this.map, this.marker);
        },

        formatGpsDateTime(dateTime) {
            if (!dateTime) return 'N/A';
            const date = new Date(dateTime);
            return date.toLocaleString();
        },
        preFillVin() {
            const vin = this.$route.params.vin;
            if (vin) {
                this.filter = vin;
            }
        },
        clearFilter() {
            this.filter = '';
            this.currentPage = 1;
            this.fetchData();
        },
        showTheftModal(vehicleId) {
            this.selectedVehicleId = vehicleId;
            this.showModal = true;
        },


        async fetchData() {
            this.loading = true;
            let apiUrl = "AllStolenVehicleindexForPolice";
            try {
                const response = await axios.get(apiUrl, {
                    params: {
                        page: this.currentPage, per_page: this.perPage,
                        ended_date: this.endDateFilter,
                        selected_date: this.startDateFilter,
                    }
                });

                this.users = response.data.data;
                this.total = response.data.total;
                this.currentPage = response.data.current_page;
                this.perPage = response.data.per_page;
                this.lastPage = response.data.last_page;
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                this.loading = false;
            }
        },

        pageChanged(newPage) {
            this.currentPage = newPage;
            this.fetchData();
        },
        // import  code 
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file && file.type === "text/csv") {
                this.fileToUpload = file;
            } else {
                alert("Please select a valid CSV file.");
            }
        },

        applyFilter() {
            this.loading = true;
            let apiUrl = "AllStolenVehicleindexForPolice";
            axios
                .get(apiUrl, {
                    params: {
                        search: this.filter,
                    },
                })
                .then((response) => {
                    this.users = response.data.data;
                    this.total = response.data.total;
                    this.currentPage = response.data.current_page;
                })
                .catch((error) => {

                })
                .finally(() => {
                    this.loading = false;
                });
        },
        openModal() {
            this.resetFormFields();

            this.modalVisible = true;
        },
        uploadDocuments() {
            this.resetUploadDocument();

            this.modalVisibleDoument = true;
        },

        onFiltered(filteredItems) {
            this.total = filteredItems.length;
            this.currentPage = 1;
        },
        uploadDocuments(studentId) {
            this.resetUploadDocument();
            this.studentId = studentId;
            this.modalVisibleDoument = true;
        },
        resetUploadDocument() {
            this.documents = "";
            this.studentId = null;
        },

        codeClick() {
            this.codeActive = !this.codeActive;
        },
        exportAllDataToCSV() {
            this.fetchAllParents((allParents) => {
                const csv = Papa.unparse(allParents);
                const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", "exported_data.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        },
        fetchAllParents(callback) {
            axios
                .get("AllStolenVehicleindexExportForPolice", { params: { per_page: this.totalRows } })
                .then((response) => {
                    callback(response.data.data);
                })
                .catch((error) => {

                });
        },

        downloadFile(fileUrl) {
            const link = document.createElement("a");
            link.href = "https://boltapi.fastnetstaffing.in/" + fileUrl;
            link.download = "downloaded_file";
            link.target = "_blank";
            link.click();
        },

        handleButtonClick(item) {
            this.updateStatus(item);
            this.toggleCardModal(item);
        },
        updateStatus(user) {
            user.status = user.status === "Approved" ? "Pending" : "Approved";
            axios
                .post(`registrationUpdate/${user.id}`, user)
                .then((response) => {

                })
                .catch((error) => {

                });
        },
        toggleCardModal(item) {
            this.selectedCardOption = "";
            this.rowToUpdate = item;
            this.isCardModalVisible = true;
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        },

        formatTime(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },
        changeDate() {
            const userId = this.$route.params.id;
            this.fetchData(userId);
        },

        seeTrack(userId, vehicleId) {
            return navigateIfVehicleLocationAvailable(this, axios, {
                userId,
                vehicleId,
                routeName: 'LiveTrackingStolenPolice',
            });
        },



    },


};
</script>
  <style>
  /* Zebra striping */
  .custom-zebra tbody tr:nth-of-type(odd) {
    background-color: #f0f2f5; /* darker than default */
  }

  /* Hover effect */
  .custom-zebra tbody tr:hover {
    background-color: #e0e4ea !important; /* slightly darker hover */
  }
  </style>